import React, { Component } from 'react'
import H1 from '../../components/H1'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import ImageViewer from '../../components/ImageViewer'
import '../../styles/css/photography.css'

const section = {
    target: 'photography',
    title: 'Photography'
}

class Photography extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            viewer: false,
            image: 0,
            limit: 999999
        }
    }

    componentDidMount = () => {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if(isMobile) {
          this.setState({ limit: 8 })
        }
    }

    showViewer = index => {
        document.body.style.overflow = "hidden"
        this.setState({
            viewer: true,
            image: index
        })
    }

    cancelViewer = () => {
        document.body.removeAttribute("style")
        this.setState({
            viewer: false
        })
    }

    showMore = () => {
        this.setState({
            limit: this.state.limit + 8
        })
    }

    render() {
        
        let { photos = [] } = this.props
        const { limit } = this.state

        photos.sort(function(a, b){return a.order - b.order})

        return(
            <div className="photography">

                {this.state.viewer && 
                <ImageViewer 
                    images={photos} 
                    currentImage={this.state.image} 
                    onCancel={this.cancelViewer} 
                />}

                <div className="photography-content">
                    <H1 section={section} />
                    <ResponsiveMasonry
                        columnsCountBreakPoints={{350: 1, 750: 2, 900: 3}} className="no-margin">
                        <Masonry gutter="10px" className="no-margin">
                            {photos.slice(0, limit).map((photo, index) => (
                                <div style={{overflow: 'hidden'}} key={index} className="mobile-photo">
                                    <img
                                        onClick={() => this.showViewer(index)}
                                        key={index}
                                        src={photo.images.medium}
                                        style={{width: "100%", display: "block"}}
                                        alt=""
                                    />
                                </div>
                            ))}
                        </Masonry>
                    </ResponsiveMasonry>
                    {limit <= photos.length && <button className="show-more" onClick={this.showMore}>Load more images</button>}
                </div>
            </div> 
        )
    }

}

export default Photography


// WEBPACK FOOTER //
// ./src/containers/home/photography.js